<template>
  <div class="dashboard">
    <StreamBarcodeReader
        @decode="onDecode"
        @loaded="onLoaded"
    ></StreamBarcodeReader>
<!--    <ImageBarcodeReader-->
<!--        @decode="onDecode"-->
<!--        @error="onError"-->
<!--    ></ImageBarcodeReader>-->
<!--    <div>-->
<!--      <scanner-->
<!--          :qrbox="250"-->
<!--          :fps="24"-->
<!--          style="width: 100vw; max-width: 500px"-->
<!--          @result="onScan"-->
<!--      />-->
<!--    </div>-->
    <div v-if="result !== null">
      {{ result }}
<!--      <div>Text: {{ result.decodedText }}</div>-->
<!--      <div>Format: {{ result.result.format.formatName }}</div>-->
    </div>
  </div>
</template>

<script>
// import Scanner from '@/components/Scanner.vue'
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  name: 'Dashboard',
  components: {
    // Scanner
    StreamBarcodeReader,
    // ImageBarcodeReader
  },
  data() {
    return {
      result: null,
    }
  },
  methods: {
    onDecode (result) {
      console.log(result);
      this.result = result
    },
    onLoaded () {
    },
    onError () {
    },
    onScan(decodedResult) {
      this.result = decodedResult;
    }
  }
}
</script>
